// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3W8GD","productName":"Table_productName__30j1V"};